export const useSxStyles = () => {
  return {
    tableHeaderRow: {
      backgroundColor: 'rgb(211,211,211,0.3)',
    },
    header: {
      color: '#05A4D8',
      fontSize: '15px',
      fontWeight: 'bold',
    },
    totalRow: {
      fontWeight: 'bold',
    },
    error: {
      color: 'red',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    customDataLabel: {
      width: 0,
      minWidth: 'fit-content',
      whiteSpace: 'nowrap',
      fontWeight: 'bold',
    },
  };
};
